<template>
  <div class="page-box">
    <el-pagination
      background
			:current-page="currentPage"
      layout="prev, pager, next"
      :page-count="totalPage"
      :page-size="limit"
      @current-change="handleCurrentChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: ["totalPage", "limit", "currentPage"],
  data() {
    return {};
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit("changePage", val);
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.page-box {
  .el-pagination {
    margin: 30px auto;
    text-align: center;
  }
}
</style>